export const CANCELLATION_REASON_OTHER = 'Other';

export const cancellationReasons = [
  'The appointment time no longer works for me.',
  'My trip plans changed or I\u2019m postponing travel.',
  'I booked with someone else or decided to plan on my own.',
  'I realized this appointment wasn\u2019t what I needed.',
  CANCELLATION_REASON_OTHER,
] as const;

export type CancellationReason = (typeof cancellationReasons)[number];

const cancellationReasonErrorTagMap: Record<string, string> = {
  'The appointment time no longer works for me.': 'appointment time no longer works',
  'My trip plans changed or I\u2019m postponing travel.': 'plans changed or postponed',
  'I booked with someone else or decided to plan on my own.': 'booked elsewhere or planned independently',
  'I realized this appointment wasn\u2019t what I needed.': 'no longer needed',
};

export const mapCancellationReasonToErrorTag = (reason: string): string => {
  const prefix = 'travel:scheduler:cancel appointment-';
  const mapped = cancellationReasonErrorTagMap[reason];
  if (mapped) return `${prefix}${mapped}`;
  return `${prefix}other`;
};
